import React, { useContext, useState, useEffect } from "react";
import "./CSS/ShopCategory.css";
import Item from "../Components/Item/Item";
import ImageSlider from "../Components/ImageSlider/ImageSlider";
import { useLocation, useNavigate } from "react-router-dom";
import arrow from '../../src/assets/arrow.png';

const ShopCategory = (props) => {
  const databaseUrl = process.env.REACT_APP_DATABASE_URL;
  const location = useLocation();
  const initialCategory = location.state?.category || props.category || "";
  const [allProducts, setAllProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [error, setError] = useState(null);
  const [productID, setProductID] = useState();
  // const [hasMore, setHasMore] = useState(true);
  const navigate = useNavigate();
  const [selectedItems, setSelectedItems] = useState([]);
  const [category, setCategory] = useState(initialCategory); // Selected category
  const [search, setSearch] = useState(""); // Search keyword
  const [page, setPage] = useState(1); // Current page
  const [limit, setLimit] = useState(10); // Items per page
  const [hasMore, setHasMore] = useState(true); // If more products are available
  const [hasMoreHome, setHasMoreHome] = useState(true);
  const [pet, setPet] = useState("");
  const [products, setProducts] = useState([]);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const query = new URLSearchParams({
        category,
        search,
        pet,
        page: page.toString(),
        limit: limit.toString(),
      }).toString();

      const response = await fetch(`${databaseUrl}/allproducts?${query}`);
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      if (page === 1) setProducts(data.products);
      else setProducts((prev) => [...prev, ...data.products]);

      if (products.length + data.products.length >= data.total) {
        setHasMore(false);
      } else setHasMore(true);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, [category, search, page, limit, pet]);

  const loadMore = () => {
    if (hasMore) {
      setPage((prev) => prev + 1); // Increment page number
    }
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const handleCategoryChange = (e) => {
    setCategory(e.target.value);
    setPage(1);
  };

  const handlePetChange = (e) => {
    setPet(e.target.value);
    setPage(1);
  };

  useEffect(() => {
    if (props.category) {
      setCategory(props.category);
    }
  }, [props.category]);

  return (
    <div className="newcollections1">
      <h1 className="text-4xl md:text-5xl text-[#551E19] font-normal mt-6 xs:mt-20 mb-4 text-center">
        Our Products
      </h1>
      <div className="search-excel mb-4 flex flex-col sm:flex-row gap-4 items-center">
        <input
          type="text"
          placeholder="Search for a product..."
          value={search}
          onChange={handleSearch}
          className="p-3 border rounded-full focus:outline-none focus:ring-[#551E19] focus:ring-2 bg-white text-gray-700 shadow-md transition duration-300 ease-in-out transform hover:scale-105"
        />
        <select
          value={category}
          onChange={handleCategoryChange}
          className="p-3 border rounded-full focus:outline-none focus:ring-[#551E19] focus:ring-2 bg-white text-gray-700 shadow-md transition duration-300 ease-in-out transform hover:scale-105"
        >
          <option value="">All Categories</option>
          <option value="dry-food">Pet Food (Dry)</option>
          <option value="wet-food">Pet Food (Wet)</option>
          <option value="toys">Pet Toys</option>
          <option value="clothes-shoes">Pet Clothes/Shoes</option>
          <option value="grooming">Pet Grooming Items</option>
          <option value="accessories">Pet Accessories</option>
          <option value="safety-wearings">Pet Safety Wearings</option>
          <option value="sanitary">Pet Sanitary Products</option>
          <option value="cages-beds">Pet Cages/Beds/Bags</option>
          <option value="other">Other Items</option>
        </select>
        <select
          value={pet}
          onChange={handlePetChange}
          className="p-3 border rounded-full focus:outline-none focus:ring-[#551E19] focus:ring-2 bg-white text-gray-700 shadow-md transition duration-300 ease-in-out transform hover:scale-105"
        >
          <option value="">All Pets</option>
          <option value="dog">Dogs</option>
          <option value="cat">Cats</option>
          <option value="bird">Birds</option>
          <option value="fish">Fishes</option>
        </select>
      </div>

      {loading ? (
        <div></div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
          {products.map((item) => (
            <div className="font-montserrat" key={item._id}>
              <Item
                id={item.id}
                name={item.name}
                image={item.image}
                new_price={item.new_price}
                old_price={item.old_price}
                rating={item.rating}
                reviewText={item.reviewText}
                no_of_rators={item.no_of_rators}
                category={item.category}
                available={item.available}
              />
            </div>
          ))}
        </div>
      )}

      {/* Load More Button */}
      {hasMore && !loading && (
        <div className="py-6 flex items-center justify-center mt-8">
          <button
            onClick={loadMore}
            className="bg-[#E6B17E] text-[#551e19] px-7 py-3 text-lg rounded-3xl hover:bg-[#c98c3c] flex items-center font-oswald"
          >
            Load More <img src={arrow} className="ml-2 h-4 w-4" />
          </button>
        </div>
      )}
      {loading && <p className="mt-4">Loading...</p>}
      {!hasMore && !loading && (
        <p className="text-[#551e19] text-xs mt-5">No more products to load.</p>
      )}
    </div>
  );
};

export default ShopCategory;
